import AsyncPage from 'pages/AsyncPage'
import universal from 'react-universal-component'
import AsyncWelcomePage from '../landing'
import { resolveHost, canShowMushtarekLanding } from './gate'

const component = universal(() => import('./MushtarekLanding'))

class AsyncMushtarekLandingPage extends AsyncPage {
  nonav = true
  // Tracks whether the gate allowed this page for the current request. Starts
  // true so SSR/head info is correct on the (common) allowed path; flipped to
  // false in prepareAdditionalAsyncData when the gate redirects to /welcome.
  private allowed = true

  constructor() {
    super({
      title: 'مشترك',
      pageComponent: component,
      isChromeless: true,
      basicDataRequirements: {
        instance: true,
        session: false,
      },
    })
  }

  createPageHeadInfo() {
    // Server-rendered <title>/<meta> for SEO (see server/render.tsx head block).
    // Only when the gate actually shows this page — otherwise AsyncPage's base
    // no-op applies, so a redirected-to-welcome request doesn't get stuck with
    // Mushtarek's title/description on top of the welcome page's own content.
    if (!this.allowed) return undefined
    return {
      title: 'مشترك | الذاكرة الوطنية العراقية',
      description:
        'مشروع الذاكرة الوطنية العراقية — رقمنة وحفظ الأعمال الفكرية والوثائق التاريخية، لنتعلّم من ذاكرتنا الوطنية ونصنع مستقبلنا.',
      keywords: ['مشترك', 'الذاكرة الوطنية العراقية', 'أعطني نوراً'],
    }
  }

  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    const state = getState()
    const instance = state.instance && state.instance.value
    const host = resolveHost(opts)
    this.allowed = canShowMushtarekLanding(host, instance)
    if (!this.allowed) {
      // Not allowed here (production, or a non-Mushtarek tenant): fall back to
      // the existing shared welcome page instead of rendering the new landing.
      // Prepare the welcome page's async data first so SSR renders it fully
      // populated (mirrors the original landing page's redirect pattern; the
      // swap is a soft render of welcome, consistent with that existing flow).
      await AsyncWelcomePage.prepareAsyncData(dispatch, getState, opts)
      await dispatch({
        type: 'home/welcome',
        meta: { location: { kind: 'redirect' } },
      })
    }
  }
}

export default new AsyncMushtarekLandingPage()
